import { connect } from 'react-redux'
import { createEducationProfileEvent } from '../actions'
import useOnMount from '../hooks/useOnMount'

function CreateEducationProfileEvent({
  eventType,
  eventAt = new Date().toJSON(),
  children = () => null,
  createEducationProfileEvent,
  triggerOnMount = false
}) {
  const callback = () => createEducationProfileEvent(eventType, eventAt)
  useOnMount(() => triggerOnMount && callback())
  return children(callback)
}

export default connect(null, { createEducationProfileEvent })(CreateEducationProfileEvent)
